import { Profile } from '@teko/user';
import { getCookieOver18YearOld } from '@teko/utils';
import { ProductInfoCategory } from '@teko/types/ecommerce';
import { isOver18YearOld } from './datetime';

const IS_LOGGED_USER_KEY = 'is_logged_user';
const IS_OVER_18_KEY = 'is_over_18';

export const needConfirm18YearsOld = (
  isAlcoholicCategory: boolean,
): boolean => {
  const isOver18YearsOld = getCookieOver18YearOld();
  return !isOver18YearsOld && isAlcoholicCategory;
};

/**
 * @param productCategories
 * @description https://jira.teko.vn/browse/UX4BUYER-5311
 * @returns true if lastest category has isAdult = true. Else return false
 */
export const isAdultCategoryProduct = (
  productCategories?: ProductInfoCategory[],
) => {
  return productCategories?.at(-1)?.isAdult;
};

/**
 * @param user
 * @description ECOM-315
 * @returns true if user confirmed their age > 18. Else return false
 */
export const requiredConfirm18YearsOld = (user: Profile | null) => {
  if (!!user) {
    // set is_logged_user = true
    // check user_age >= 18 => over 18 flow
    // else set is_over_18 = false => under 18 flow
    localStorage.setItem(IS_LOGGED_USER_KEY, 'true');
    if (user.dob && isOver18YearOld(user?.dob)) {
      return false;
    } else {
      localStorage.setItem(IS_OVER_18_KEY, 'false');
      return true;
    }
  } else {
    // check is_logged_user
    if (localStorage.getItem(IS_LOGGED_USER_KEY) === 'true') {
      // set is_logged_user = false
      // set is_over_18 = false
      // => under 18 flow
      localStorage.setItem(IS_LOGGED_USER_KEY, 'false');
      localStorage.setItem(IS_OVER_18_KEY, 'false');
      return true;
    } else {
      //  check is_over_18 = true => over 18 flow
      //  else => under 18 flow
      if (localStorage.getItem(IS_OVER_18_KEY) === 'true') {
        return false;
      } else {
        return true;
      }
    }
  }
};

export const markUserIsOver18 = () => {
  localStorage.setItem(IS_OVER_18_KEY, 'true');
};
